import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "style/ModalStyles.css";
import MsgModal from "./MsgModal";
import { requestPost } from "utils/AxiosApi";
const WithdrawalModal = (props: any) => {
  let history = useNavigate();
  //모달창 open
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");

  useEffect(() => {
    document.body.style.cssText = `
          position: fixed; 
          top: -${window.scrollY}px;
          overflow-y: scroll;
          width: 100%;`;
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = "";
      window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
    };
  }, []);

  const [confirmText, setConfirmText] = useState("");

  const inputChange = (e: any) => {
    const { value } = e.target;
    setConfirmText(value);
  };

  const withdrawalMember = async () => {
    let data = await requestPost("/api/member/withdrawal", {});

    if (data.result) {
      setModalOpen(true);
      setModalMsg("회원탈퇴 처리가 완료되었습니다.");
    }
  };

  const msgModalConfirm = () => {
    history("/login");
  };

  return (
    <div className="modalBackground">
      <div className="modalContainer-edit-password">
        <h2 id="font-SCD4">회원 탈퇴</h2>
        <br></br>
        <div className="termsBody" id="font-SCD3">
          <div
            className="display-center-margin-0"
            style={{ padding: "0 10px" }}
          >
            <div className="">
              <div className="span-black-text">
                <span className="">
                  탈퇴를 원하시면 '회원탈퇴'를 적어주세요.
                </span>
              </div>
              <input
                onChange={inputChange}
                className="input-form-w97p-40"
                type="text"
                name="confirmText"
                placeholder="회원탈퇴"
                value={confirmText}
              ></input>
            </div>
          </div>
        </div>
        <div className="mfooter">
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button
              className={
                confirmText === "회원탈퇴" ? "terms-cancel" : "terms-cancel-off"
              }
              id="font-SCD4"
              onClick={() => withdrawalMember()}
              disabled={confirmText !== "회원탈퇴"}
            >
              회원탈퇴
            </button>
            <button
              className="terms-agree"
              onClick={() => props.setOpenModal(false)}
              id="font-SCD4"
            >
              취소
            </button>
          </div>
        </div>
      </div>
      {modalOpen && (
        <MsgModal
          setOpenModal={setModalOpen}
          modalMsg={modalMsg}
          modalConfirm={msgModalConfirm}
        ></MsgModal>
      )}
    </div>
  );
};

export default WithdrawalModal;
